module.exports = __webpack_public_path__ + "img/card_250810863.bca33d8f.jpg";